module.exports = "/static/assets/339c155417f00f3c8f34a1e04fa8636f.png";